import React from 'react';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';
import classNames from 'classnames';
import {Tooltip} from 'react-tooltip';

import analytic from 'utils/Analytic';


function AnswerKeyButton({challenge_version, lesson, is_preview, is_bonus}) {
    function getIsChallengePreview() {
        return isEmpty(lesson) && is_preview
    }

    function getButtonClassName() {
        return classNames('btn btn-large', {
            'btn-white': get(lesson, 'is_answer_keys_shown'),
            'btn-maybe': isEmpty(lesson) && is_preview
        });
    }

    function getTooltipProps() {
        if (getIsChallengePreview()) {
            return {
                'data-tooltip-id': 'answer-key-button-tooltip',
                'data-tooltip-content': 'You can choose to have the Answer Key on or off'
            }
        } else {
            return {}
        }
    }

    function getAnswerKeyUrl() {
        if (is_bonus) {
            return `/resource/${challenge_version.challenge_code.code}/answer-key-bonus.pdf`;
        } else {
            return `/resource/${challenge_version.challenge_code.code}/answer-key.pdf`;
        }
    }

    function getButtonLabel() {
        if (is_bonus) {
            return `Download Answer Key - Bonus`
        } else {
            return `Download Answer Key`
        }
    }

    function onClick() {
        const event_name = is_bonus ? 'downloadBonusAnswerKey' : 'downloadAnswerKey'
        analytic.log(event_name, {
            id: challenge_version.id,
            name: challenge_version.name,
            code: challenge_version.challenge_code.code
        }, get(lesson, 'id'))
    }

    function renderTooltip() {
        if (getIsChallengePreview()) {
            return (
                <Tooltip
                    id="answer-key-button-tooltip"
                    place='top'
                    delayHide={99999}
                    defaultIsOpen={true}
                />
            );
        }

        return null
    }

    if (!challenge_version.answer_key_url) {
        return null;
    }

    const is_answer_keys_shown = get(lesson, 'is_answer_keys_shown');
    if (!isEmpty(lesson) && !is_answer_keys_shown) {
        return null;
    }

    return (
        <div className="answer-key-button">
            <a
                className={getButtonClassName()}
                href={getAnswerKeyUrl()}
                target="_blank"
                onClick={onClick}
                {...getTooltipProps()}
            >
                <i className="fas fa-download"></i>
                <span className='no-wrap'>
                        {getButtonLabel()}
                    </span>
            </a>

            {renderTooltip()}
        </div>
    );
}

AnswerKeyButton.propTypes = {
    challenge_version: PropTypes.shape({
        answer_key_url: PropTypes.string.isRequired,
        bonus_answer_key_url: PropTypes.string.isRequired,
        challenge_code: PropTypes.shape({
            code: PropTypes.string.isRequired
        }).isRequired,
    }).isRequired,
    lesson: PropTypes.object,
    is_preview: PropTypes.bool,
    is_bonus: PropTypes.bool.isRequired
}

export default AnswerKeyButton
